// prizes.js — 景品と換金（純粋モジュール / ブラウザAPI非依存）
//
// 玉 →（ホールの景品カウンター）→ 景品 →（店の外の交換所）→ イン
// →（ホールの景品カウンター）→ 玉  という一周ができる。
//
// 換金率は景品ごとにまるで違う。特殊景品はほぼ等価で戻せるかわりに何も
// 面白くなく、ぬいぐるみや黄金の玉は戻すと大損する。手元に置いておきたい
// ものほど換金には向かない、という関係にしてある。
//
// 名前と説明は言語ごとに変わるので js/locales/ にある。ここは id と値だけ。

import { t } from './i18n.js';

/** イン 1 につき何発の玉と交換できるか */
export const BALLS_PER_ING = 4;

export const RARITY = {
  common: { color: '#8ea6d4' },
  rare: { color: '#5cdb95' },
  epic: { color: '#c77dff' },
  legend: { color: '#ffd166' },
};

export const prizeName = (p) => t(`prize.${p.id}.name`);
export const prizeBlurb = (p) => t(`prize.${p.id}.blurb`);
export const groupLabel = (g) => t(`prize.group.${g}`);

/**
 * cost … 交換に要る玉
 * ing  … 交換所が払ってくれるイン
 * 換金率 = ing * BALLS_PER_ING / cost（表示は rateOf）
 */
export const PRIZES = [
  // --- 特殊景品。換金のためだけにある。ほぼ等価で戻せる ---
  {
    id: 'tokusyu-bronze', icon: '🥉', rarity: 'common',
    cost: 125, ing: 30, group: 'special',
  },
  {
    id: 'tokusyu-silver', icon: '🥈', rarity: 'common',
    cost: 500, ing: 120, group: 'special',
  },
  {
    id: 'tokusyu-gold', icon: '🥇', rarity: 'rare',
    cost: 2500, ing: 600, group: 'special',
  },

  // --- お菓子・日用品 ---
  {
    id: 'tissue', icon: '🧻', rarity: 'common',
    cost: 100, ing: 5, group: 'snack',
  },
  {
    id: 'ramune', icon: '🍬', rarity: 'common',
    cost: 200, ing: 20, group: 'snack',
  },
  {
    id: 'choco', icon: '🍫', rarity: 'common',
    cost: 250, ing: 25, group: 'snack',
  },
  {
    id: 'cupnoodle', icon: '🍜', rarity: 'common',
    cost: 350, ing: 35, group: 'snack',
  },

  // --- おもちゃ ---
  {
    id: 'keyholder', icon: '🔑', rarity: 'common',
    cost: 600, ing: 50, group: 'toy',
  },
  {
    id: 'plush', icon: '🧸', rarity: 'rare',
    cost: 1200, ing: 100, group: 'toy',
  },
  {
    id: 'rccar', icon: '🚗', rarity: 'rare',
    cost: 2600, ing: 220, group: 'toy',
  },
  {
    id: 'figure', icon: '🗿', rarity: 'epic',
    cost: 3000, ing: 200, group: 'toy',
  },

  // --- 家電・ブランド ---
  {
    id: 'earphone', icon: '🎧', rarity: 'rare',
    cost: 5000, ing: 700, group: 'goods',
  },
  {
    id: 'ricecooker', icon: '🍚', rarity: 'epic',
    cost: 9000, ing: 1300, group: 'goods',
  },
  {
    id: 'watch', icon: '⌚', rarity: 'epic',
    cost: 20000, ing: 3000, group: 'goods',
  },

  // --- 別格 ---
  {
    id: 'bromide', icon: '🃏', rarity: 'legend',
    cost: 30, ing: 1, group: 'legend',
  },
  {
    id: 'goldenball', icon: '🏆', rarity: 'legend',
    cost: 50000, ing: 2000, group: 'legend',
  },
];

export const PRIZE_GROUPS = [...new Set(PRIZES.map((p) => p.group))];

export const findPrize = (id) => PRIZES.find((p) => p.id === id) || null;

/** 換金率（1.0 で等価）。特殊景品だけがこれに近い */
export const rateOf = (p) => (p.ing * BALLS_PER_ING) / p.cost;

/** コレクションに何種類そろっているか */
export function collected(collection) {
  return PRIZES.filter((p) => (collection?.[p.id] || 0) > 0).length;
}

/** 持っている景品の総数 */
export function totalOwned(collection) {
  return PRIZES.reduce((n, p) => n + (collection?.[p.id] || 0), 0);
}

/** 保存されていたコレクションを均す。知らない id や変な数は落とす */
export function sanitizeCollection(raw) {
  const out = {};
  if (!raw || typeof raw !== 'object') return out;
  for (const p of PRIZES) {
    const n = Math.floor(Number(raw[p.id]));
    if (Number.isFinite(n) && n > 0) out[p.id] = Math.min(n, 9999);
  }
  return out;
}
